import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCard = ({ title, value, change, changeType, icon, iconBg, iconColor }) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-brand hover:shadow-brand-lg transition-brand">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <h3 className="text-3xl font-bold text-foreground mb-2">{value}</h3>
          {change && (
            <div className="flex items-center gap-1">
              <Icon 
                name={changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'} 
                size={16} 
                color={changeType === 'increase' ? 'var(--color-success)' : 'var(--color-destructive)'} 
              />
              <span className={`text-sm font-medium ${changeType === 'increase' ? 'text-success' : 'text-destructive'}`}>
                {change}
              </span>
              <span className="text-sm text-muted-foreground ml-1">vs last month</span>
            </div>
          )}
        </div>
        <div className={`${iconBg} p-3 rounded-lg`}>
          <Icon name={icon} size={24} color={iconColor} />
        </div>
      </div>
    </div>
  );
};

export default StatsCard;